module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAASCAYAAABy+8PSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMxJREFUeNrs2sENwWAch+FW3MUGju3JCJiAbmAFG1jBCCbACDbg1CsbMAF/SSXiojctz5P80iYahy95D6JplmW35LNjdR0mQFM8uhzEep8e7Nb8QoFD89TusuOs4PcJHYQOCB0QOiB04Auhr2L9sizTuBaOBlppEZtUe77/kqQvL8wUEfn2+UGe54fE/+fQJudoePDS8Cwum/fQz7Fl7BKbx6bODVpnHTtV9+PY6D104A9+owNCB4QOCB0QOtCA0PeOChpnF7vWefAuwABhIx79myLzpAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/RAPZ1.png
// module id = x2o1
// module chunks = 0